import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './PayoutInfoHint.css';

/**
 * Compact box shown at CHARGE time with the business's receiving data for the
 * chosen method (PIX key / bank details), plus a copy-to-clipboard button so
 * the operator can paste it to the client. Renders nothing when there's no
 * configured value — the hint never nags about unconfigured methods.
 */
const PayoutInfoHint: React.FC<{ title: string; value?: string | null; dataCy?: string }> = ({
    title, value, dataCy,
}) => {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);
    if (!value || !value.trim()) return null;
    return (
        <div className="payout-hint" data-cy={dataCy ?? 'payout-hint'}>
            <div className="payout-hint__head">
                <span className="payout-hint__title">{title}</span>
                <button
                    type="button"
                    className={`payout-hint__copy${copied ? ' is-copied' : ''}`}
                    onClick={async () => {
                        try {
                            await navigator.clipboard.writeText(value);
                            setCopied(true);
                            setTimeout(() => setCopied(false), 2000);
                        } catch { /* clipboard blocked — value is still visible to copy by hand */ }
                    }}
                >
                    {copied ? t('payments.payout.copied') : t('payments.payout.copy')}
                </button>
            </div>
            <div className="payout-hint__value">{value}</div>
        </div>
    );
};

export default PayoutInfoHint;
